import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export function useCartCount(userId?: string | null) {
  const { data } = useQuery({
    queryKey: ["cart-count", userId],
    queryFn: async () => {
      if (!userId) return 0;
      const { data: cart } = await supabase
        .from("carts")
        .select("id")
        .eq("user_id", userId)
        .maybeSingle();
      if (!cart?.id) return 0;
      const { count } = await supabase
        .from("cart_items")
        .select("id", { count: "exact", head: true })
        .eq("cart_id", cart.id);
      return count ?? 0;
    },
    enabled: !!userId,
  });
  return data ?? 0;
}
